import { useRecommendedForYouArticlesQuery } from '../../../generated/frontend'
import type { CandidatesType } from '../MultiModelsRecommendedForYou/MultiModelsRecommendedForYou'
import { MultiModelsRecommendedForYou } from '../MultiModelsRecommendedForYou/MultiModelsRecommendedForYou'
import type { Layout } from '../Recommendations'
import { getModelsData, Model, Recommendations } from '../Recommendations'

export const modelRecommendationsExperiment: CandidatesType = {
  control: Model.RECENT_CATEGORY,
  variant: Model.VECTOR_RECOMMENDATION,
}

type MultiModelRecommendationsProps = {
  whichId: string
  layout: Layout
  position?: string
}

export const MultiModelRecommendations = ({
  whichId,
  layout,
  position,
}: MultiModelRecommendationsProps) => {
  const { data, loading } = useRecommendedForYouArticlesQuery()

  if (loading) {
    return null
  }

  const models = getModelsData(data?.recommendations?.models ?? [])

  if (
    models[modelRecommendationsExperiment.control] &&
    models[modelRecommendationsExperiment.variant]
  ) {
    return (
      <MultiModelsRecommendedForYou
        models={models}
        whichId={whichId}
        layout={layout}
        candidates={modelRecommendationsExperiment}
        position={position}
      />
    )
  }

  return (
    <Recommendations
      model={models[Model.RECENT_CATEGORY]}
      whichId={whichId}
      layout={layout}
      position={position}
    />
  )
}
